/*
 * Zahnheld form error focus
 * ---------------------------------------------------------------------------
 * Server-rendered form errors are announced unreliably. A screen reader reads a
 * live region when its content CHANGES; a `role="alert"` that is already in the
 * DOM at first paint has never changed, so most combinations stay silent. That
 * is why snippets/banner.liquid carries the live region but cannot be the whole
 * answer.
 *
 * The reliable half is moving focus to the message (WCAG 3.3.1). Focus makes the
 * assistive technology read the banner, scrolls it into view for everyone else,
 * and puts the keyboard right above the field that failed.
 *
 * Three conditions, all of them deliberate:
 *
 *   - Only error banners. A success message that steals focus is an annoyance,
 *     not an aid.
 *   - Only if focus is still on the body. If the page took a while and someone
 *     has already started typing, taking focus away is worse than staying quiet.
 *   - Only if the banner is actually visible. The password-recovery form on the
 *     login page renders hidden until it is opened, and focusing a hidden
 *     element does nothing on some browsers and scrolls to nowhere on others.
 */
(function () {
  'use strict';

  function focusFirstError() {
    var active = document.activeElement;

    // Anything other than body/html means the visitor or another script got
    // there first. Their intent wins.
    if (active && active !== document.body && active !== document.documentElement) {
      return;
    }

    var banners = document.querySelectorAll('.banner--error[tabindex="-1"]');

    for (var i = 0; i < banners.length; i++) {
      var banner = banners[i];

      // offsetParent is null for display:none and for anything inside it, which
      // is exactly the hidden-form case. It is also null for position:fixed, and
      // no banner in this theme is fixed.
      if (banner.offsetParent === null) {
        continue;
      }

      banner.focus();
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusFirstError, { once: true });
  } else {
    focusFirstError();
  }
})();
